// extracted by mini-css-extract-plugin
export default {"container":"VendingMapping_container__fskya","title":"VendingMapping_title__DgKMJ","column":"VendingMapping_column__sSO3X","list":"VendingMapping_list__bjcUd"};